"use strict";

exports.__esModule = true;
exports.DeviceDataTable = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DataTable = require("../../Core/DataTable/DataTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceDataTable = exports.DeviceDataTable = (0, _styledComponents["default"])(_DataTable.DataTable).withConfig({
  displayName: "DeviceDataTable",
  componentId: "sc-sn3ptj-0"
})([".rt-tbody{overflow-x:hidden;}"]);